import type { SteeringResponse } from '../types';

export function connectCalendarExample(): SteeringResponse {
  return {
    action: 'CONNECT_CALENDAR',
    attributes: {},
    title: 'Connect your calendar',
    message: 'Sync your calendar to unlock meeting preparation and follow-up suggestions.',
  };
}

export function createClientExample(): SteeringResponse {
  return {
    action: 'CREATE_CLIENT',
    attributes: { email_address: 'jane@example.com', first_name: 'Jane', last_name: 'Smith' },
    title: 'Add a new client',
    message: 'Jane Smith recently enquired — create their profile to get started.',
  };
}

export function createMeetingAgendaExample(): SteeringResponse {
  return {
    action: 'CREATE_MEETING_AGENDA',
    attributes: { meeting_id: 'meeting-1' },
    title: 'Prepare your meeting agenda',
    message: 'You have an upcoming meeting — prepare an agenda to make the most of it.',
  };
}

export function createMeetingNotesExample(): SteeringResponse {
  return {
    action: 'CREATE_MEETING_NOTES',
    attributes: { meeting_id: 'meeting-1' },
    title: 'Generate meeting notes',
    message: 'Your recent meeting is ready for notes — generate them now.',
  };
}

export function dataUploadFromMeetingExample(): SteeringResponse {
  return {
    action: 'DATA_UPLOAD_FROM_MEETING',
    attributes: { meeting_id: 'meeting-1' },
    title: 'Upload meeting documents',
    message: 'Upload documents discussed during your recent meeting.',
  };
}

export function dataUploadExample(): SteeringResponse {
  return {
    action: 'DATA_UPLOAD',
    attributes: { client_id: 'client-1' },
    title: 'Upload client documents',
    message: 'Upload documents for processing and entity detection.',
  };
}

export function createSuitabilityReportExample(): SteeringResponse {
  return {
    action: 'CREATE_SUITABILITY_REPORT',
    attributes: { client_id: 'client-1' },
    title: 'Create suitability report',
    message: 'Generate a suitability report for your client.',
  };
}
